import React from 'react';
import { LandingChatInterface } from '../../components/LandingChatInterface';
import { ChatMessage, ModalType } from '../../types';
import { StreamStatus } from '../../services/apiService';

interface ChatSectionProps {
    messages: ChatMessage[];
    onSend: (prompt: string, files: File[]) => void;
    isLoading: boolean;
    openModal: (type: ModalType) => void;
    samplePrompts: { title: string; prompt: string; }[];
    onLoginClick: () => void;
    onSignUpClick: () => void;
    onReset: () => void;
    onReadMore: () => void;
    // Streaming status props
    streamingStatus?: StreamStatus | null;
    streamingMessage?: string | null;
    streamingResultsCount?: number;
}

const ChatSection: React.FC<ChatSectionProps> = ({ 
    messages, 
    onSend, 
    isLoading, 
    openModal, 
    samplePrompts,
    onLoginClick,
    onSignUpClick,
    onReset,
    onReadMore,
    streamingStatus = null,
    streamingMessage = null,
    streamingResultsCount = 0
}) => {
  const miniWelcomeMessage = "Hi! I'm Cosmos Mini — a preview to help you scout high-potential university innovations. I can help you with";
  
  // Dynamic height with responsive design: 
  // Desktop: 500px minimum, Mobile: adaptive height
  const hasMessages = messages.length > 0 || isLoading;
  
  // Responsive height classes - use viewport height on mobile for better fit
  const desktopHeight = hasMessages ? 'lg:h-[700px]' : 'lg:h-[500px]'; // Desktop: 500px min, 700px with messages
  const mobileHeight = hasMessages ? 'h-[calc(100vh-200px)] min-h-[600px] max-h-[800px]' : 'h-[calc(100vh-200px)] min-h-[500px] max-h-[700px]'; // Mobile: adaptive height
  
  return (
    <div className={`flex flex-col ${mobileHeight} ${desktopHeight} rounded-2xl shadow-[0_12px_16px_0_rgba(225,215,201,0.16)] overflow-hidden bg-grayscale-100 transition-all duration-300 ease-in-out w-full max-w-full`}>
      <div className="flex flex-1 min-h-0">
        <LandingChatInterface 
          messages={messages}
          onSend={onSend}
          isLoading={isLoading}
          openModal={openModal}
          samplePrompts={samplePrompts}
          welcomeMessage={miniWelcomeMessage}
          showConciergeLink={false}
          onResetChat={onReset}
          showResetButton={true}
          onReadMore={onReadMore}
          streamingStatus={streamingStatus}
          streamingMessage={streamingMessage}
          streamingResultsCount={streamingResultsCount}
        />
      </div>
      <div className="p-2 sm:p-4 pt-0 text-center bg-grayscale-100 shrink-0 w-full overflow-x-hidden">
         <p className="text-[10px] sm:text-xs font-grotesk whitespace-normal break-words">
          {/* <span className="text-black">Cosmos features cutting-edge technology and research from 10 leading universities across the USA. <br/>Cosmos Mini is a preview with limited features. For full access, </span> */}
          <button onClick={onLoginClick} className="font-bold text-primary-600 underline">Login</button>
          <span className="text-black"> or </span>
          <button onClick={onSignUpClick} className="font-bold text-primary-600 underline">Sign Up</button>
        </p>
      </div>
    </div>
  );
};

export default ChatSection;